// extracted by mini-css-extract-plugin
export default {"card":"StoryCard_card__g1Kw0","img":"StoryCard_img__MJoV6","desc":"StoryCard_desc__-Jju9","title":"StoryCard_title__nxILc","icon":"StoryCard_icon__ODhmA"};